<template>
  <div class="formItem">
    <el-form
      label-position="right"
      :label-width="labelWidth"
      :model="params"
      :rules="rules"
      ref="queryFrom"
      :validate-on-rule-change="false"
      :disabled="disabled"
    >
      <el-row>
        <div v-for="(baseColumn, i) in baseColumns" :key="i">
          <template v-for="(column, index) in baseColumn">
            <template v-if="!column.isHide">
              <el-col v-if="column.type == 'input-area'" :key="column.name" :span="24">
                <el-form-item :label="column.name" :prop="column.prop">
                  <!--输入框-->
                  <el-tooltip
                    :disabled="!params[column.prop]"
                    class="item"
                    effect="dark"
                    :content="params[column.prop]"
                    placement="top"
                  >
                    <el-input
                      style="width: 100%"
                      :maxlength="column.maxlength || 32"
                      v-model="params[column.prop]"
                      :placeholder="column.placeholder || $t('search.input')"
                      clearable
                      :readonly="column.readonly || false"
                      :disabled="column.disabled || false"
                    ></el-input>
                  </el-tooltip>
                </el-form-item>
              </el-col>

              <el-col v-else :key="index" :span="column.span || 6">
                <!--开始时间-->
                <template v-if="column.type == 'startDaterangePicker'">
                  <el-form-item
                    :label="column.name"
                    :prop="column.prop"
                    :class="{ propClass: column.name?.trim().length > propLength }"
                  >
                    <el-date-picker
                      clearable
                      style="width: 100%"
                      v-model="params[column.prop]"
                      type="date"
                      :placeholder="column.placeholder || $t('search.choose')"
                      value-format="yyyy-MM-dd"
                      :disabled="column.disabled"
                      :picker-options="pickerStartOptions"
                      @focus="() => handleFocusDate('start', column.prop, column.index)"
                    ></el-date-picker>
                  </el-form-item>
                </template>
                <!--结束时间-->
                <template v-else-if="column.type == 'endDaterangePicker'">
                  <el-form-item
                    :label="column.name"
                    :prop="column.prop"
                    :class="{ propClass: column.name?.trim().length > propLength }"
                  >
                    <el-date-picker
                      clearable
                      style="width: 100%"
                      v-model="params[column.prop]"
                      type="date"
                      :placeholder="column.placeholder || $t('search.choose')"
                      value-format="yyyy-MM-dd"
                      :disabled="column.disabled"
                      :picker-options="pickerEndOptions"
                      @focus="() => handleFocusDate('end', column.prop, column.index)"
                    ></el-date-picker>
                  </el-form-item>
                </template>
                <template v-else-if="column.type == 'placeholder'">
                  <span></span>
                </template>
                <!--checkbox-->
                <template v-else-if="column.type == 'checkbox'">
                  <el-form-item label-width="90px" :prop="column.prop">
                    <el-checkbox
                      v-model="params[column.prop]"
                      :true-label="column.trueLable"
                      :false-label="column.falseLable"
                      :disabled="column.disabled || false"
                      @change="(val) => handleChange(val, column.prop, column.changeMethod)"
                      >{{ column.name }}
                    </el-checkbox>
                    <el-button
                      style="margin-left: 20px; height: 30px"
                      type="primary"
                      v-if="column.moreBtn || false"
                      @click="changeMethod(column.key, '', column.changeMethod)"
                      >{{ $t('salePurchase.search.credit') }}</el-button
                    >
                  </el-form-item>
                </template>
                <el-form-item
                  v-else
                  :label="column.name"
                  :class="{ propClass: column.name?.trim().length > propLength }"
                  :prop="column.prop"
                >
                  <el-tooltip
                    :disabled="!params[column.prop]"
                    class="item"
                    effect="dark"
                    :content="String(params[column.prop])"
                    placement="top"
                  >
                    <!--输入框-->
                    <el-input
                      style="width: 100%"
                      v-if="column.type == 'input'"
                      :maxlength="column.maxlength || 32"
                      v-model="params[column.prop]"
                      :placeholder="column.placeholder || $t('search.input')"
                      clearable
                      :readonly="column.readonly || false"
                      :disabled="column.disabled || false"
                      @input="(val) => handleChange(val, column.prop, column.changeMethod)"
                    >
                      <template slot="append" v-if="column?.append">{{ column?.append }}</template>
                    </el-input>
                  </el-tooltip>
                  <!--数字输入-->
                  <el-tooltip
                    :disabled="!params[column.prop]"
                    class="item"
                    effect="dark"
                    :content="String(params[column.prop])"
                    placement="top"
                  >
                    <el-input
                      clearable
                      style="width: 100%"
                      v-if="column.type == 'inputNumber'"
                      v-model="params[column.prop]"
                      :maxlength="column.maxlength || 32"
                      :placeholder="column.placeholder || $t('search.input')"
                      :disabled="column.disabled || false"
                      @input="
                        (val) =>
                          limitAmount(
                            val,
                            column.max,
                            column.prop,
                            column.changeMethod,
                            column.precision
                          )
                      "
                    >
                      <template v-if="column.append" slot="append">{{ column.append }}</template>
                    </el-input>
                  </el-tooltip>
                  <!--单选框-->
                  <!-- <el-tooltip
                      class="item"
                      effect="dark"
                      placement="top"
                      v-if="column.type=='select'"
                      :disabled="!params[column.prop]"
                      :content="params[column.prop] ?
                      column.options.find(item => item[column.value || 'value'] === params[column.prop])[column.label || 'label'] : ''" > -->
                  <el-select
                    style="width: 100%"
                    v-if="column.type == 'select'"
                    v-model="params[column.prop]"
                    :placeholder="column.placeholder || $t('search.choose')"
                    @change="
                      (val) => {
                        changeMethod(val, column.relatedColumn, column.changeMethod, column.prop);
                      }
                    "
                    @clear="
                      (val) => {
                        clearMethod(val, column.clearMethod);
                      }
                    "
                    filterable
                    :clearable="column.clearabled || true"
                    :disabled="column.disabled || false"
                    :multiple="column.multiple || false"
                  >
                    <el-option
                      v-for="(item, index) in column.options"
                      :key="index"
                      :label="item[column.label || 'label']"
                      :value="item[column.value || 'value']"
                    ></el-option>
                  </el-select>
                  <!-- </el-tooltip> -->
                  <!--获取后端数据渲染的下拉框-->
                  <ajax-select
                    style="width: 100%"
                    v-if="column.type == 'ajaxSelect'"
                    v-model="params[column.prop]"
                    :placeholder="column.placeholder || $t('search.choose')"
                    :apiUrl="column.apiUrl"
                    :apiData="column.apiData"
                    :multiple="column.multiple || false"
                    :clearable="column.clearable || true"
                    :filterable="column.filterable || true"
                    :dataString="column.dataString"
                    :valueKey="column.valueKey"
                    :labelKey="column.labelKey"
                    :method="column.method"
                    :moreShowKey="column.moreShowKey"
                    :valueType="column.valueType || 'string'"
                    :disabled="column.disabled"
                    @change="(val) => handleChange(val, column.prop, column.changeMethod)"
                  ></ajax-select>
                  <!--日期-->
                  <el-date-picker
                    style="width: 100%"
                    v-if="column.type == 'date'"
                    v-model="params[column.prop]"
                    type="date"
                    :placeholder="column.placeholder || $t('search.choose')"
                    value-format="yyyy-MM-dd"
                    :clearable="column.clearable || true"
                    :disabled="column.disabled"
                    :picker-options="column.pickerOptions"
                    @focus="() => handleSendDate(column.prop)"
                    @change="(val) => handleChange(val, column.prop, column.changeMethod)"
                  ></el-date-picker>
                  <!--tree-->
                  <tree-select
                    style="width: 100%"
                    ref="treeSelect"
                    v-if="column.type == 'treeSelect'"
                    :model="column.prop"
                    :apiUrl="column.apiUrl"
                    :apiData="column.apiData"
                    :clearable="column.clearable || true"
                    :currentValue="column.currentValue || null"
                    :returnType="column.returnType || ''"
                    :disabled="disabled || column.disabled"
                    @setSearchModal="setSearchModal"
                  ></tree-select>
                  <!-- 下拉表格 -->

                  <el-tooltip
                    v-if="column.type == 'searchTableSpec'"
                    :disabled="!column.currentValue && !params[column.name]"
                    class="item"
                    effect="dark"
                    :content="column.currentValue || params[column.name]"
                    placement="top"
                  >
                    <search-table
                      ref="searchTable"
                      v-if="column.type == 'searchTableSpec'"
                      v-model="params[column.prop]"
                      :searchType="column.searchType"
                      :checkRowKeys="column.checkRowKeys"
                      :currentValue="column.currentValue"
                      :isMultiple="column.isMultiple"
                      :extraData="column.extraData"
                      :disabled="column.disabled"
                      @input="(val) => handleChange(val, column.prop, column.changeMethod)"
                    >
                    </search-table>
                  </el-tooltip>
                  <!--inputLocal-->
                  <el-row :gutter="0">
                    <el-col :span="12" style="padding-right: 5px">
                      <el-input
                        v-if="column.type == 'inputLocal'"
                        v-model="params[column.prop]"
                        :placeholder="column.placeholder || $t('search.input')"
                        :precision="column.precision"
                        :disabled="column.disabled || false"
                        @input="
                          (val) =>
                            limitAmount(
                              val,
                              column.max,
                              column.prop,
                              column.changeMethod,
                              column.precision
                            )
                        "
                        @change="
                          (val) => blurAmount(val, column.max, column.prop, column.changeMethod)
                        "
                        clearable
                        :maxlength="column.maxlength || 32"
                      ></el-input>
                    </el-col>
                    <el-col :span="12" style="padding-left: 5px">
                      <el-input
                        v-if="column.moreInput"
                        v-model="params[column.moreProp]"
                        :disabled="column.moreDisabled"
                        :placeholder="column.morePlaceholder || $t('search.input')"
                        clearable
                        :maxlength="column.maxlength || 32"
                      ></el-input>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-col>
            </template>
          </template>
        </div>
      </el-row>
    </el-form>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import { toFormErrorTop } from '@/common/js/util';

  // import SearchModal from '@/components/SearchModal';
  import ajaxSelect from '@/components/form-item/ajax-select';
  import treeSelect from '@/components/form-item/tree-select';
  import searchTable from '@/components/form-item/search-table';
  import BASE_API from '@/api/dataBase.js';

  export default {
    name: 'formItem',
    components: {
      // SearchModal,
      ajaxSelect,
      treeSelect,
      searchTable, // 弹窗搜索：包括 商品、人员等，可新增
    },
    data() {
      return {
        pickerStartOptions: {}, // 开始日期配置
        pickerEndOptions: {}, // 结束日期配置
        pickerOptions: {},
        flag: false, //标记短装比例
      };
    },
    props: {
      params: {
        type: Object,
        default: () => {},
      },
      labelWidth: {
        type: String,
        default: '100px',
      },
      /**
       * columns筛选参数：
       * name:'名称'
       * prop:'字段名字'
       * type'编辑类型',['inpput','select','selectMultiple','date','datetime']
       * options:当编辑类型是select时的初始数据。
       * maxlength:可输入的最大长度
       */
      columns: {
        type: Array,
        default: () => [],
      },
      /**
       * 校验规则
       */
      rules: {
        type: Object,
        default: () => {},
      },
      /**
       * 日期
       */
      date: {
        type: String,
        default: () => '',
      },
      /**
       * 是否可编辑
       */
      disabled: {
        type: Boolean,
        default: () => false,
      },
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      baseColumns() {
        let areaList = [];
        let result = [];
        let list = [];
        for (let i = 0; i < this.columns.length; i++) {
          if (this.columns[i].type != 'input-area') {
            if (!this.columns[i].isHide) list.push(this.columns[i]);
          } else {
            areaList.push([this.columns[i]]);
          }
        }
        for (let i = 0; i < list.length; i += 4) {
          result.push(list.slice(i, i + 4));
        }
        return result.concat(areaList);
      },
      propLength() {
        return this.$store.getters.language == 'zh_CN' ? 6 : 14;
      },
    },
    mounted() {
      this.getDepartmentList();
    },
    methods: {
      // 清除校验
      clearValidate(val) {
        this.$refs.queryFrom.clearValidate(val);
      },
      handleFocusDate(type, prop, index) {
        const dateProp =
          type == 'start' ? this.columns[index + 1].prop : this.columns[index - 1].prop;
        const pickerOptions = {
          disabledDate: (time) => {
            return this.disabledDate(time, dateProp, type);
          },
        };
        if (type == 'start') {
          this.pickerStartOptions = pickerOptions;
        } else {
          this.pickerEndOptions = pickerOptions;
        }
      },
      handleSendDate(prop) {
        if (
          prop == 'lastestShipmentDate' ||
          prop == 'lastestDeliveryDate' ||
          prop == 'lastestPayMoneyDay' ||
          prop == 'lastestReceiveProductDay' ||
          prop == 'lastestReceiveMoneyDay' ||
          prop == 'lastestSendProductDay' ||
          prop == 'lastestShipmentDate' ||
          prop == 'lastestDeliveryDate'
        ) {
          if (this.date == '') {
            this.pickerOptions = {};
          } else {
            const pickerOptions = {
              disabledDate: (time) => {
                return time.getTime() < new Date(this.date).getTime() - 24 * 60 * 60 * 1000;
              },
            };
            this.pickerOptions = pickerOptions;
          }
        }
        // else if (
        //   prop == "lastestReceiveMoneyDay" ||
        //   prop == "lastestSendProductDay"
        //   ) {
        //   const pickerOptions = {
        //     disabledDate: time => {
        //       return time.getTime() < new Date().getTime() - 24 * 60 * 60 * 1000;
        //     }
        //   };
        //   this.pickerOptions = pickerOptions;
        // }
        else {
          this.pickerOptions = {};
        }
      },
      // 开始结束日期禁用日期
      disabledDate(time, prop, type) {
        if (type === 'end') {
          let startDate = this.params[prop];
          if (startDate) {
            return time.getTime() < new Date(startDate).getTime() - 24 * 60 * 60 * 1000;
          }
        } else {
          let endDate = this.params[prop];
          if (endDate) {
            return time.getTime() > new Date(endDate).getTime();
          }
        }
      },
      //设置表单值
      setSearchModal(model, row) {
        if (model == 'isFixedPrice') {
          if (row == 0) {
            this.params['pricingRule'] = null;
          }
          this.$refs.queryFrom.clearValidate('pricingRule');
          this.params[model] = row;
        } else if (model == 'contractBusinessDepartment') {
          //如果是业务部门
          this.params[model] = row.id;
          this.params.contractBusinessDepartmentName = row.label;
          this.$emit('changeCurrency', { val: this.params[model], prop: model });
        } else if (model == 'creditAmount') {
          //如果是赊销
          if (this.params.isCreditsale == 1) {
            this.params[model] = row;
          }
        } else if (model == 'overShippedPercentage' || model == 'shortShippedPercentage') {
          //如果是溢装比例或者短装比例
          this.params[model] = this.params[model] ? this.params[model] : row;
        } else if (model == 'createDepartmentName' || model == 'saleDepartmentName') {
          this.params[model] = row;
          this.$emit('departmentChanged', { val: row, prop: model });
        } else {
          this.params[model] = row;
        }
      },
      //number限制长度和位数
      limitAmount(value, max, prop, method, precision) {
        if (!value) this.params[`${prop}Local`] = '';
        value = value.toString().replace(/[^\d.]/g, ''); //清除"数字"和"."以外的字符
        value = value.toString().replace(/^\./g, ''); //验证第一个字符是数字
        value = value.toString().replace(/\.{2,}/g, '.'); //只保留第一个, 清除多余的
        value = value.toString().replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
        if (precision == 1) {
          value = value.toString().replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3'); //只能输入一位小数
        } else if (precision == 2) {
          value = value.toString().replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两位小数
        } else if (precision == 3) {
          value = value.toString().replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3'); //只能输入四位小数
        } else if (precision == 4) {
          value = value.toString().replace(/^(\-)*(\d+)\.(\d\d\d\d).*$/, '$1$2.$3'); //只能输入四位小数
        } else if (precision == 5) {
          value = value.toString().replace(/^(\-)*(\d+)\.(\d\d\d\d\d).*$/, '$1$2.$3'); //只能输入五位小数
        } else if (precision == 0) {
          value = value.toString().replace(/^(0+)|[^\d]+/g, '');
        } else {
          value = value.toString().replace(/^(\-)*(\d+)\.(\d\d\d\d\d\d).*$/, '$1$2.$3'); //只能输入六位小数
        }
        if (Number(value) >= Number(max)) {
          value = max;
        }
        if (prop == 'overShippedPercentage') {
          if (!this.flag) {
            this.params['shortShippedPercentage'] = value;
          }
        }
        if (prop == 'shortShippedPercentage') {
          var val = this.params['shortShippedPercentage'];
          var notNull = !val && typeof val != 'undefined';
          if (!notNull) {
            this.flag = true;
          } else {
            this.flag = false;
          }
        }
        this.params[prop] = value;
        if (!method) {
          return;
        }
        //运输信息不调用父页面方法
        // if (
        //   prop == "freightExpense" ||
        //   prop == "storageExpense" ||
        //   prop == "outInExpense" ||
        //   prop == "loadingUnitPrice" ||
        //   prop == "deliveryUnitPrice" ||
        //   prop == "acceptanceDiscountUnitPrice"
        // ) {
        //   return;
        // }
        this.$emit(method, { prop: prop, val: value });
      },
      blurAmount(value, max, prop, method) {
        this.$emit(method, { prop: prop, val: this.params[prop] });
      },
      //选中塞值
      handleChange(val, prop, method) {
        //如果定价，则清空定价规则的必填校验
        if (prop == 'isFixedPrice') {
          this.params['pricingRule'] = null;
          this.$refs.queryFrom.clearValidate('pricingRule');
        }
        //如果是不是预付,则清空预付金额
        //如果是不是赊销,则清空赊销金额
        if (prop == 'isCreditsale') {
          this.params['creditAmount'] = null;
        }
        if (!method) {
          return;
        }
        if (prop == 'contractBusinessDepartment') {
          this.params.contractBusinessDepartmentName = this.departmentList.find((item) => {
            return item.personDepartmentCode == val;
          }).personDepartmentName;
          //业务部门选择供应商弹窗关闭
          this.$refs.searchTable[0].blurModal();
        }
        this.$emit(method, { val: val, prop: prop });
      },
      //select修改事件
      changeMethod(val, relatedColumn, method, prop) {
        if (!method) {
          return;
        }
        if (relatedColumn) {
          this.params[relatedColumn] = null;
        }
        if (prop) {
          console.log('11????', val, relatedColumn, method, prop);
          this.$emit(method, { val: val, prop: prop });
        } else {
          this.$emit(method, { val: val });
        }
      },
      clearMethod(val, method) {
        if (!method) {
          return;
        }
        this.$emit(method, { val: val });
      },
      //基本信息的值 进行重新赋值
      // 获取表单的值
      getValues() {
        const data = this.params;
        const result = Object.assign({}, data, {
          adminFlag: this.userInfo.userInfo.adminFlag,
          tenantCode: this.userInfo.userInfo.tenantCode,
          companyCode: this.userInfo.userInfo.companyCode,
          companyName: this.userInfo.userInfo.companyName,
          departmentCode: this.userInfo.userInfo.departmentCode,
          departmentName: this.userInfo.userInfo.departmentName,
          contractTotalAmount: data.contractTotalAmount
            ? data.contractTotalAmount.replace(/,/g, '')
            : '',
          // customerNo: data.customer ? data.customer[0].partnerCode : null, // 客户编码
          // customerName: data.customer ? data.customer[0].partnerZhName : null, // 客户名称
          // supplierNo: data.supplier ? data.supplier[0].partnerCode : null, // 供应商编码
          // supplierName: data.supplier ? data.supplier[0].partnerZhName : null // 供应商名称
        });
        //总金额
        return result;
      },
      validate(fn) {
        this.$refs.queryFrom.validate((valid) => fn(valid, valid ? this.params : {}));
      },
      getValidateFormData() {
        return new Promise((resolve, reject) => {
          this.$refs.queryFrom.validate((valid) => {
            if (valid) {
              resolve(this.params);
            } else {
              this.$message.error('请检查表单资料是否正确填写');
              toFormErrorTop();
              reject({});
            }
          });
        });
      },
      //校验
      submit(type) {
        //客户民称校验
        if (this.params.customer == null || this.params.customer[0].customerNo == null) {
          this.params.customer = null;
        }
        return new Promise((resolve, reject) => {
          if (type == '0') {
            resolve();
          } else {
            this.$refs['queryFrom'].validate((valid) => {
              if (valid) {
                resolve();
              } else {
                // 验证错误跳转至第一个错误提示得地方
                toFormErrorTop();
                reject();
                return false;
              }
            });
          }
        });
      },
      // 获取当前登录人所在的部门
      getDepartmentList() {
        const params = {
          id: this.userInfo.userInfo.userCode,
          userCode: this.userInfo.userInfo.userCode,
          personName: this.userInfo.userInfo.userName,
          personCompanyCode: this.params.supplierNo,
        };
        this.$axios.post(BASE_API.GET_PERSON_API, params).then((res) => {
          if (res.data.code === 0) {
            this.departmentList = res.data.data.personDepartmentInfo;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .formItem {
    text-align: left;
  }
</style>
